import React, { Component } from 'react'
import { Link } from "react-router-dom"
import { Tooltip } from "antd"
import PropTypes from "prop-types"

class BatchQuantity extends Component {

    render() {
        const { item } = this.props
        const { statistic, production_process = {} } = { ...item }
        const { name: productionProcessName } = production_process || {}

        return (
            <td className="text-center font-18 Quantity">
                <Link
                    to={{
                        pathname: `/batches/${item._id}`,
                        search: `?status=pending`
                    }}
                >
                    <Tooltip title="Đang chờ">
                        <strong className="text-info">{statistic.pending || 0}</strong>
                    </Tooltip>
                </Link>/
                {productionProcessName === 'Thêu' ?
                    <Link
                        to={{
                            pathname: `/batches/${item._id}`,
                            search: `?status=designed`
                        }}
                    >
                        <Tooltip title="Đã thiết kế">
                            <strong className="text-success">{statistic.designed || 0}</strong>
                        </Tooltip>
                    </Link> :
                    <Link
                        to={{
                            pathname: `/batches/${item._id}`,
                            search: `?status=confirmed`
                        }}
                    >
                        <Tooltip title="QC sau ép">
                            <strong className="text-success">{statistic.confirmed || 0}</strong>
                        </Tooltip>
                    </Link>
                }/
                {productionProcessName === 'Thêu' ?
                    <Link
                        to={{
                            pathname: `/batches/${item._id}`,
                            search: `?&status=embroidered`
                        }}
                    >
                        <Tooltip title="Đã thêu">
                            <strong className="text-success">{statistic.embroidered || 0}</strong>
                        </Tooltip>
                    </Link> :
                    <Link
                        to={{
                            pathname: `/batches/${item._id}`,
                            search: `?&status=moved`
                        }}
                    >
                        <Tooltip title="Đã moved">
                            <strong className="text-success">{statistic.moved || 0}</strong>
                        </Tooltip>
                    </Link>
                }/
                <Link
                    to={{
                        pathname: `/batches/${item._id}`,
                        search: `?status=completed`
                    }}
                >
                    <Tooltip title="Hoàn thành">
                        <strong className="text-success">{statistic.completed || 0}</strong>
                    </Tooltip>
                </Link>/
                <Link
                    to={{
                        pathname: `/batches/${item._id}`
                    }}
                >
                    <Tooltip title="Tổng">
                        <strong className="text-primary">{statistic.total || 0}</strong>
                    </Tooltip>
                </Link>
            </td>
        )
    }
}

BatchQuantity.propTypes = {
    item: PropTypes.object.isRequired,
}

export default BatchQuantity